// Helpers for working with the inline `preview` field returned on Artefact references.

/**
 * Decode an Artefact `preview` data URL (e.g. `data:text/plain;charset=utf-8;base64,...`)
 * into a plain UTF-8 string. Returns the input unchanged if it isn't a base64 data URL.
 */
export const decodeArtefactPreview = (
    preview: string | null | undefined
): string => {
    if (!preview) return "";
    const match = preview.match(/^data:[^,]*;base64,(.*)$/);
    if (!match) return preview;
    try {
        const bytes = Uint8Array.from(atob(match[1]), (c) => c.charCodeAt(0));
        return new TextDecoder("utf-8").decode(bytes);
    } catch {
        return "";
    }
};
